<template>
	<span
		class="help has-error admin-form-error"
		v-if="formName.errors.has(propName)"
		role="alert"
		aria-live="polite"
		v-text="formName.errors.get(propName)"
	></span>
</template>

<script>
	export default {
		props:['formName','propName']
	}
</script>